import { isGenericAnalytic } from "../../../Types/AnalysisDetails";
import { ModalityGraphConfigJSON } from "../../../Types/Graph";
import { getFullTraceDataConfigs } from "../../../Types/Trace";
import { activeGoal } from "../../../Types/GoalRanges";

// A goal strip row judging an analysis such as PRx has no stored modality of its own.
const isAnalysisGoalRow = (trace: any) => trace.onDemandAnalysis?.source !== undefined && !isGenericAnalytic(trace.onDemandAnalysis.source.analytic)

// A hidden measurement whose goal bar still shows keeps its graph, so the bar keeps its legend label.
const barShown = (trace: any) => !!activeGoal(trace)?.heatmap && !activeGoal(trace)?.barHidden

export function getVisibleGraphs<T extends ModalityGraphConfigJSON>(graphs: T[], patientModalities: string[], hideEmptyGraphs: boolean) {
    if (!hideEmptyGraphs) {
        return graphs
    }

    return graphs.filter(graph => graph.traces
        .filter(trace => (trace.isVisible ?? true) || barShown(trace))
        .flatMap(getFullTraceDataConfigs)
        .some(trace => 
            patientModalities.includes(trace.rawDataKey) || (trace.onDemandAnalysis !== undefined && !isGenericAnalytic(trace.onDemandAnalysis?.analytic))
            || isAnalysisGoalRow(trace))
        )
}